export const OPEN_STREET_MAP_PROJECTION = 'WGS84';
// export const OPEN_STREET_MAP_URL = 'https://tile.openstreetmap.org/';
export const OPEN_STREET_MAP_URL = 'https://osm.pointshareplus.com/tile';
// export const OPEN_STREET_MAP_URL = 'https://pointsharecloud.online/osm/tile';

export const OSM_ATTRIBUTION_ID = 'osmAttribution';

export const DEFAULT_PANORAMA_BUBBLE_RADIUS = 0.15; // in meters

// Sprint Icon Marker
export const PANORAMA_MARKER_GREEN=`${Potree.resourcePath}/images/custom_menu/panorama-marker-green.png`;
export const PANORAMA_MARKER_ORANGE=`${Potree.resourcePath}/images/custom_menu/panorama-marker-orange.png`;
